// Home.js
import React from 'react';
import './Home.css';
import p1 from './homepage.png';
import { useNavigate } from 'react-router-dom';

const Home = () => {
  const navigate = useNavigate();

  return (
    <div className="home-container">
      {/* ------------ HERO SECTION ------------ */}
      <section
        className="hero"
        style={{ backgroundImage: `url(${p1})` }}
      >
        <div className="hero-overlay" />
        <div className="hero-text">
          <h1>Bulletproof Interviewing</h1>
          <p>
            Confidence. Clarity. Results. Get coached by someone who’s been on both sides of the
            interview table.
          </p>
          <button onClick={() => navigate('/pricing')} className="cta-btn">
            Explore Coaching Options
          </button>
        </div>
      </section>
   <h2>What We Offer</h2>
      {/* ------------ FEATURES ------------ */}
      <section className="features">
     
        <div className="feature-box">
          <h2>1‑on‑1 Interview Coaching</h2>
          <p>
            Personalized guidance designed to prepare you for structured, high‑stakes interviews in
            law enforcement, public safety, and security fields.
          </p>
        </div>
        <div className="feature-box">
          <h2>Group Coaching</h2>
          <p>
            Join focused group sessions with real‑time feedback, behavioral question drills, and
            peer learning in a supportive environment.
          </p>
        </div>
      </section>
   <h2>Hear From Our Clients</h2>
      {/* ------------ TESTIMONIAL ------------ */}
      <section className="testimonial">
        <h2>Real Success Story</h2>
       <p>★★★★★</p> 
        <p className="review-text">
          "Mark was both insightful and highly observant. He helped me secure a Police Constable
          position by coaching me through mock interviews and helping me refine my responses."
        </p>
        <p className="review-author">— James C.</p>
        <button onClick={() => navigate('/reviews')} className="cta-btn">
          Read More Reviews
        </button>
      </section>
       <div className="cta">
        <h3>Not Sure Which Option Is Right for You?</h3>
        <p>
          Contact me for a <strong>free consultation</strong> or to ask any questions before
          booking.
        </p>
        <button className="cta-btn" onClick={()=>{
            navigate('/contact')}}>Contact Us</button>
      </div>
    </div>
  );
};

export default Home;

